import { render, staticRenderFns } from "./passwordFindMaterial.vue?vue&type=template&id=0c1de993&scoped=true"
import script from "./passwordFindMaterial.vue?vue&type=script&lang=js"
export * from "./passwordFindMaterial.vue?vue&type=script&lang=js"
import style0 from "./passwordFindMaterial.vue?vue&type=style&index=0&id=0c1de993&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1de993",
  null
  
)

export default component.exports